import Checks from './checks';

export default Checks;
